import React, { useState, useEffect } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../../firebaseConfig"; // Importando a configuração do Firebase para criar referência
import "./AddUserModal.css";
import { FaSearch } from "react-icons/fa";
import {
  extractDomainFromEmail,
  filterUsersByPermissions,
  getDomainsBySubsidiaries,
  getUserBySubsidiaries,
} from "../../../../utils/userHelpers";

function AddUserModal({
  module,
  onClose,
  onSave,
  usersData,
  userRole,
  userInformations,
}) {
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectAll, setSelectAll] = useState(false); // Estado para o checkbox de selecionar todo
  const [permittedDomains, setPermittedDomains] = useState([]);
  const [subsidiariesUsers, setSubsidiariesUsers] = useState([]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleCheckboxChange = (email) => {
    if (selectedUsers.includes(email)) {
      setSelectedUsers(selectedUsers.filter((user) => user !== email));
    } else {
      setSelectedUsers([...selectedUsers, email]);
    }
  };

  // Função para selecionar ou desmarcar todos os usuários
  const handleSelectAllChange = () => {
    if (selectAll) {
      setSelectedUsers([]); // Desmarcar todos
    } else {
      // Selecionar todos os usuários filtrados
      const allEmails = filteredUsers.map((user) => user.email);
      setSelectedUsers(allEmails);
    }
    setSelectAll(!selectAll); // Alterna o estado de selecionar todos
  };

  useEffect(() => {
    const getDomains = async () => {
      const domains = await getDomainsBySubsidiaries(
        userInformations.subsidiaries
      );
      setPermittedDomains(domains);
    };

    getDomains();
  }, [userInformations.subsidiaries]);

  useEffect(() => {
    const loadUsers = async () => {
      const users = await getUserBySubsidiaries(userInformations.subsidiaries);
      setSubsidiariesUsers(users);
    };

    loadUsers();
  }, [userInformations.subsidiaries]);

  // Filtra usuários com base nos permittedDomains e subsidiariesUsers
  const filteredUsers = filterUsersByPermissions(usersData, {
    userRole,
    permittedDomains,
    subsidiariesUsers,
    searchTerm,
    moduleId: module.id,
    excludeUsersInModule: true,
    userSubsidiaries: userInformations.subsidiaries,
  });

  const handleSave = () => {
    // Aqui criamos as referências corretas para o módulo no Firestore
    const moduleRef = doc(db, "modules", module.id); // Cria referência ao módulo no Firestore
    onSave(selectedUsers, moduleRef); // Passa a lista de usuários selecionados e a referência do módulo para o onSave
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <h2>Add Users to {module.pageName}</h2>
        <div className="modal-search-input">
          <div className="search-bar-modal">
            <FaSearch className="search-icon-modal" />
            <input
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={handleSearchChange}
              className="search-input-modal"
            />
          </div>
        </div>

        {/* Checkbox de selecionar todos */}
        <div className="select-all-container">
          <label>
            <input
              type="checkbox"
              checked={selectAll}
              onChange={handleSelectAllChange}
            />
            Select All
          </label>
        </div>

        <div className="user-list-container">
          {filteredUsers.map((user) => (
            <label key={user.email} className="user-card">
              <input
                type="checkbox"
                checked={selectedUsers.includes(user.email)}
                onChange={() => handleCheckboxChange(user.email)}
              />
              <span>
                {user.name || user.email} ({user.email})
              </span>
            </label>
          ))}
        </div>
        <div className="modal-actions">
          <button onClick={onClose}>Cancel</button>
          <button onClick={handleSave}>Save</button>
        </div>
      </div>
    </div>
  );
}

export default AddUserModal;
